module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_9005.c70278c1.png";